import { Routes } from '@angular/router';
import { paymentRulesRedirect } from '../../../../shared/payment-rules/payment-rules-redirects';
import { residentRedirect } from '../../../../shared/benefits-page/benefits-redirects';

export const MOBILE_MENU_ROUTES: Routes = [
  // Хаб и CMS-страницы льгот заменены страницей about-benefits (UIMSP-1450).
  {
    path: 'children/benefits-and-resident-membership',
    pathMatch: 'full',
    redirectTo: '/mobile/main/about-benefits',
  },
  {
    path: 'page/categories-of-citizens-eligible-for-benefits',
    pathMatch: 'full',
    redirectTo: '/mobile/main/about-benefits',
  },
  {
    path: 'page/online-application-submission',
    pathMatch: 'full',
    redirectTo: '/mobile/main/about-benefits',
  },
  { path: 'page/resident-abonement', pathMatch: 'full', redirectTo: residentRedirect('mobile') },
  // Способы оплаты и штрафы заменены страницей payment-rules (прототип 1a).
  {
    path: 'children/payment-method',
    pathMatch: 'full',
    redirectTo: '/mobile/main/payment-rules',
  },
  {
    path: 'page/payment-using-a-mobile-app',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('mobile', 'app'),
  },
  {
    path: 'page/payment-via-payment-terminals',
    pathMatch: 'full',
    redirectTo: paymentRulesRedirect('mobile', 'terminal'),
  },
  { path: 'page/fines', pathMatch: 'full', redirectTo: paymentRulesRedirect('mobile', 'fines') },
  {
    path: 'page/:slug',
    loadComponent: () => import('./pages').then(c => c.MenuPageComponent),
  },
  {
    path: 'children/:slug',
    loadComponent: () => import('./pages').then(c => c.MenuChildrenComponent),
  },
];
